module.exports = __webpack_public_path__ + "img/Season202425_EN600x200-2.f9c6e94e.png";